import { Preview } from './Preview';
import { ParamData } from './ParamData';

export enum TableColumnKey {
  pfhNo = 'pfhNo',
  CreditCurrency = 'creditCurrency',
  CreditAmount = 'creditAmount',
  ValidationPass = 'validationPass',
  ValidationError = 'validationError',
}

export type TableRow = {
  [TableColumnKey.pfhNo]?: string;
  [TableColumnKey.CreditCurrency]?: string;
  [TableColumnKey.CreditAmount]?: string;
  [TableColumnKey.ValidationPass]: boolean;
  [TableColumnKey.ValidationError]?: string;
  paramData?: ParamData;
  ['rawData']: Preview;
};
